import React from "react";
//import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { fNumber } from '../../../../utils/formatNumber';

const LineChart = ({chartData}) => {

  const options = {
    plugins: {
      title: {
        display: true,
        text: "Stacked",
      },
    },
    responsive: true,
    offsetGridLines: true,
    drawTicks: true,
    layout: {
      padding: {
        top: 30,
        right: 40,
        bottom: 40,
      },
    },
    legend: {
      display: true,
      position: "top",
      align: "center",
      labels: {
        usePointStyle: true,
      },
    },

    maintainAspectRatio: false,
    scales: {
      // xAxes: [
      //   {
      //     stacked: true,
      //     ticks: {
      //       padding: 5,
      //     },
      //     gridLines: {
      //       display: false,
      //     },
      //   },
      // ],
      yAxes: [
        {
          stacked: false,
          gridLines: {
            drawBorder: false,
          },
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 6,
            padding: 20,
            // callback(n) {
            //   if (n < 1e3) return n;
            //   if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
            // },
            callback: function (label, index, labels) {
              //return label / 1000 + "k";
              return fNumber(label);
            },
          },
        },
      ],
    },
  };

  

  return (
    <div>
      {chartData &&<Bar data={chartData} height={400} options={options} />}
    </div>
  );
};
export default LineChart;
